import * as React from 'react';

import FourOhFour from '../404';

function ProductCatchAll() {
  // track invalid product slugs maybe?
  return <FourOhFour />;
}

export default ProductCatchAll;
